import { AdditionalData } from "views/applications-id-report/slices/CombinedIncomeReportSlice/types/verified/bank-statment";
import { getGenericReasonCodes } from "../../utils";
import { AuthenticityScoreAlert } from "views/applications-id-report/slices/CombinedIncomeReportSlice/components/AuthenticityScoreAlert";
import { resolveAuthenticityTone } from "views/applications-id-report/slices/CombinedIncomeReportSlice/utils/authenticityTone";
import {
  resolveAuthenticityScore,
  resolveDocumentUrl,
  resolveFraudRisk,
  resolveRiskSummary
} from "views/applications-id-report/slices/CombinedIncomeReportSlice/utils/fraudRisk";
import { Show } from "shared/components";
import {
  resolveDocumentProblems,
  toFraudRiskLines
} from "views/applications-id-report/slices/CombinedIncomeReportSlice/utils/documentProblems";
import { DocumentIssueAlert } from "views/applications-id-report/slices/CombinedIncomeReportSlice/components/DocumentIssueAlert";
import { documentWithoutDatesTableColumns } from "views/applications-id-report/slices/CombinedIncomeReportSlice/helpers";
import { ExpandableTable } from "views/applications-id-report/slices/CombinedIncomeReportSlice/components/UniversalTable";
import { UploadedIncomeSource } from "views/applications-id-report/slices/CombinedIncomeReportSlice/types/income";

export const UnverifiedIncomeSourceTable = ({
  incomeSources
}: {
  incomeSources: UploadedIncomeSource[];
}) => {
  return (
    <ExpandableTable
      cellClassName="p-4 pl-0 text-sm self-center"
      headerRowClassName="text-content-300"
      renderExpanded={(row) => {
        const additionalData = (row.rejection_reason ?? []).reduce(
          (additionalData, reason) => {
            additionalData[reason] = true;
            return additionalData;
          },
          {} as AdditionalData
        );

        const reasonCodes = getGenericReasonCodes(
          additionalData,
          row.verifyType
        );

        const score = resolveAuthenticityScore(row) ?? row.trust_score ?? null;
        const problems = resolveDocumentProblems(row);

        return (
          <div className="p-6 bg-background-900 space-y-3">
            <Show if={problems.length > 1}>
              {problems.map((problem) => (
                <DocumentIssueAlert
                  key={problem.label}
                  label={problem.label}
                  description={problem.description}
                />
              ))}
            </Show>

            <AuthenticityScoreAlert
              tone={resolveAuthenticityTone(resolveFraudRisk(row), score)}
              score={score}
              issues={toFraudRiskLines(reasonCodes, resolveRiskSummary(row))}
            />
          </div>
        );
      }}
      columns={documentWithoutDatesTableColumns}
      getViewUrl={resolveDocumentUrl}
      rows={(incomeSources ?? []).map((item) => ({
        ...item,
        verifyType: item.type,
        asset: item.asset
      }))}
    />
  );
};
